const iframe = document.getElementById('MyTimeIFrame');

  // Wait for the iframe to load
  iframe.addEventListener('load', function() {
    setTimeout(function() {
      // Move the keyboard focus inside the iframe
      iframe.contentWindow.focus();
    }, 200);
  });